// Auth context — JWT bearer + user state.
import { createContext, useContext, useEffect, useState } from "react";
import { api, setAccessToken, getAccessToken } from "@/api/client";

const AuthContext = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const t = getAccessToken();
      if (!t) { setLoading(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch { setAccessToken(null); }
      finally { setLoading(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAccessToken(data.access_token);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setAccessToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export const hasRole = (user, ...roles) => user && roles.includes(user.role);
export const minRole = (user, min) => {
  const H = { admin: 4, finance: 3, ops: 2, readonly: 1 };
  return user && (H[user.role] || 0) >= (H[min] || 0);
};
